module.exports = __webpack_public_path__ + "static/media/viewAccess.4903a866.svg";